const multiAudio = () => {
    // Lecteur audio multi HTML5
    document.querySelectorAll('.c-audio--multi').forEach(audioContainer => {
        const audio = audioContainer.querySelector('audio');
        const playlist = audioContainer.querySelector('.c-audio__playlist');
        const trackLinks = playlist.querySelectorAll('li a');
        let current = 0;

        // Première piste active
        trackLinks[0].classList.add('c-audio__track--active');

        // Choix des pistes
        trackLinks.forEach((trackLink, index) => {
            trackLink.addEventListener('click', function (e) {
                e.preventDefault();

                // Remplacement des sources
                while (audio.firstChild) {
                    audio.removeChild(audio.firstChild);
                }
                const source1 = document.createElement('source');
                source1.type = this.getAttribute('data-type');
                source1.src = this.getAttribute('href');
                audio.appendChild(source1);

                if (this.hasAttribute('data-srcbis')) {
                    const source2 = document.createElement('source');
                    source2.type = this.getAttribute('data-typebis');
                    source2.src = this.getAttribute('data-srcbis');
                    audio.appendChild(source2);
                }

                // Changement de la piste active
                trackLinks.forEach(link => link.classList.remove('c-audio__track--active'));
                this.classList.add('c-audio__track--active');
                current = index;

                // Reload, lecture de la piste, focus
                audio.load();
                audio.play(); // TODO : A tester, bug potentiel
                audio.focus();
            });
        });

        // Piste suivante
        audio.addEventListener('ended', function () {
            current = current >= trackLinks.length - 1 ? 0 : current + 1;
            trackLinks[current].click();
        });
    });
}

document.addEventListener('DOMContentLoaded', multiAudio);
